import { AsyncDuckDB } from '@duckdb/duckdb-wasm';
import { Table as Arrow } from 'apache-arrow';

/**
 * Execute a SQL query, and return the result as an Apache Arrow table.
 */
export const runQuery = async (
  db: AsyncDuckDB,
  sql: string,
  logDuckQueries = false
): Promise<Arrow> => {
  const start = performance.now();
  const conn = await db.connect();
  const arrow = await conn.query(sql);
  await conn.close();

  if (logDuckQueries) {
    console.log(
      `Run query: ${sql}`,
      `Time spent: ${(performance.now() - start).toFixed(0)}`
    );
  }

  return arrow;
};
